import React, { useState, useEffect, useMemo, useRef, memo } from 'react'
import { useSelector } from 'react-redux'
import axios from 'axios'
import { makeStyles } from '@material-ui/core/styles'
import { Typography, Box, Grid } from '@material-ui/core'

import _, { get } from 'lodash'
import { Route, Redirect } from 'react-router-dom'

import EditComponent from '../EntryListAndEdit/EditComponent.js'
import AddComponent from '../EntryListAndEdit/AddComponent.js'
import ViewComponent from '../EntryListAndEdit/ViewComponent.js'

import {ecosackState} from '../../utils/ecosackState';
import {utc_timestamp_to_local_date_string, utc_timestamp_to_hours_ago_string, utc_timestamp_to_local_datetime_string} from '../../utils/datetime_utc_local.js'
import loading_gif from "../../assets/img/loading.gif";

const useStyles = makeStyles((theme) => ({}))

const PaginatedList = (props) => {
  const classes = useStyles()

  const auth = useSelector(state => state.auth)
  const [isLoading, setIsLoading] = useState(false);
  const [entries, setEntries] = useState([])
  const [page, setPage] = useState(1)
  const [perPage, setPerPage] = useState(0)
  const [numPages, setNumPages] = useState(1)
  const [total, setTotal] = useState(0)
  const [pagelinks, setPagelinks] = useState([])
  const [searchterm, setSearchterm] = useState("")
  const [isInitialLoad, setIsInitialLoad] = useState(true);
  // Tracks the request currently in flight, so a new one (new keystroke,
  // page change, or the customertable_is_dirty event) can cancel it instead
  // of letting it run to completion and potentially overwrite newer results
  // with stale ones.
  const abortControllerRef = useRef(null);

	const {
		list_get_url,
		detail_get_url,
		add_new_url,
		view_request,
		column_names,
		header_names,
		optional_column_names,
		optional_header_names,
	} = props;

  useEffect(() => {
    const fetchListData = async () => {
      // Cancel whatever's still in flight before starting a new request -
      // otherwise an earlier, slower request (e.g. from a search term typed
      // a moment ago) can complete *after* a newer one and overwrite its
      // results with stale data, on top of just wasting backend work.
      if (abortControllerRef.current) {
        abortControllerRef.current.abort();
      }
      const controller = new AbortController();
      abortControllerRef.current = controller;

      setIsLoading(true);
      const config = {
        headers: { 'Content-Type': 'application/json' },
        signal: controller.signal,
      }

      if (auth.access_token) {
        config.headers.Authorization = `Bearer ${auth.access_token}`
      }

      var results;
      try {
        if(searchterm == ""){
          results = await axios.get(list_get_url + page, config)
        }else{
          results = await axios.get(list_get_url + searchterm + "/" + page, config)
        }
      } catch (err) {
        if (axios.isCancel(err) || err.code === 'ERR_CANCELED') {
          // Superseded by a newer request - that one owns updating state
          // (including isLoading), so just bail out quietly here.
          return;
        }
        setIsLoading(false);
        throw err;
      }

      setTotal(results.data.total)
      setNumPages(results.data.pages)
      setPerPage(results.data.per_page)

      let these_pagelinks = [];
      for(var i=1; i<results.data.pages+1; i++){
        these_pagelinks.push(i)
      }
      setPagelinks(these_pagelinks);

      console.log(these_pagelinks);

      for (var i in results.data.items) {
        for (const [key, value] of Object.entries(results.data.items[i])) {
          if (key == 'balance' || key == 'donated' || key == 'earned redemption' || key == 'withdrawn') {
            results.data.items[i][key] = '$' + (results.data.items[i][key] / 1e6);
          }
        }
      }
      setEntries(results.data.items)
      setIsLoading(false);
      setIsInitialLoad(false);
    }

    fetchListData();

    window.addEventListener('customertable_is_dirty', fetchListData);
    return () => {
      window.removeEventListener('customertable_is_dirty', fetchListData);
    }
  }, [page, searchterm])

  // Debounced so a fast typist doesn't fire one request per keystroke - the
  // input itself is uncontrolled (defaultValue, not value below), so this
  // doesn't introduce any lag in what's displayed while typing, only in
  // when the search actually gets sent. Stable across renders (useMemo with
  // no deps) so lodash's internal timer isn't reset/recreated every render.
  const debouncedSetSearchterm = useMemo(
    () => _.debounce((value) => setSearchterm(value), 300),
    []
  );

  useEffect(() => {
    return () => debouncedSetSearchterm.cancel();
  }, [debouncedSetSearchterm]);

  const onChangeSearchterm = (event) => {
    debouncedSetSearchterm(event.target.value)
  };

  if (!auth.access_token) {
    return <Redirect to="/login" />
  }

  function createPaginationLinks(top){
      return <Grid container>
          <br/>
          <Grid sm={12} md={8}>
              {page > 1 &&
                  <span onClick={() => setPage(page-1)}  style={{'marginRight':'5px', 'cursor':'pointer'}}>&lt;&lt;</span>
               }
               {page == 1 &&
                  <span style={{'marginRight':'5px', 'opacity':0.3}}>&lt;&lt;</span>
               }

              {pagelinks.length <= 10 &&
                  _.map(pagelinks, pl =>{
                      if(pl == page){
                          return <span style={{'marginRight':'5px', 'textDecoration':'underline', 'opacity':0.3}}>{pl}</span>
                      }else{
                          return <span onClick={() => setPage(pl)}  style={{'marginRight':'5px', 'cursor':'pointer'}}>{pl}</span>
                      }
                  })
              }

              {pagelinks.length > 10 &&
                  _.map(pagelinks, pl =>{
                      if(pl == page){
                          return <span style={{'marginRight':'5px', 'textDecoration':'underline', 'opacity':0.3}}>{pl}</span>
                      }else if(pl < (page+5) && pl > (page-5) ){
                          return <span onClick={() => setPage(pl)}  style={{'marginRight':'5px', 'cursor':'pointer'}}>{pl}</span>
                      }
                  })
              }

              {page < numPages &&
                  <span onClick={() => setPage(page+1)}  style={{'marginRight':'5px', 'cursor':'pointer'}}>&gt;&gt;</span>
               }
               {page == numPages &&
                  <span style={{'marginRight':'5px', 'opacity':0.3}}>&gt;&gt;</span>
               }

              {page < numPages &&
                  " ("+((page-1)*perPage+1) + "-" + page*perPage+" of "+total+")"
              }
              {page == numPages &&
                  " ("+((page-1)*perPage+1) + "-" + total+" of "+total+")"
              }
          </Grid>
          <Grid sm={12} md={4}>

          {top &&
              <>
              <label htmlFor="searchterm" style={{'display':'inline-block', 'marginRight':'5px'}}>Search</label>
              <input type="text" name="searchterm" id="searchterm" defaultValue={searchterm} onChange={onChangeSearchterm} />
              </>
          }

          </Grid>
          <br/>
          </Grid>
  }

  function createSearchBox(){
    return(
        <Grid container>
          <Grid sm={12} md={8}>{total} results</Grid>
          <Grid sm={12} md={4}>
            <label htmlFor="searchterm" style={{'display':'inline-block', 'marginRight':'5px'}}>Search</label>
            <input type="text" name="searchterm" id="searchterm" defaultValue={searchterm} onChange={onChangeSearchterm} />
          </Grid>
        </Grid>
        )
  }

  if (isInitialLoad && isLoading) {  
    return(
      <Grid container spacing={3}>
        <Grid xs={12} style={{'textAlign': 'center'}}>
          <img src={loading_gif} style={{'width': '150px'}}/>
        </Grid>
      </Grid>
      )
    }
          
  return(<>
  
    {numPages > 1 && createPaginationLinks(true)}

    {numPages <= 1 && createSearchBox()}

    <table class='table table-striped' style={{'width':'100%'}}>
    <thead>
      <tr>
      {_.map(header_names, hn => {
          return <th style={{'padding':'10px'}}>{hn}</th>
      })}

    {window.innerWidth > 1080 &&
        _.map(optional_header_names, hn => {
        return <th style={{'padding':'10px'}}>{hn}</th>
    })
    }

    {view_request !== undefined &&
      <th style={{ textAlign: 'right' }}>View</th>
    }
    {detail_get_url !== undefined &&
        <th style={{'textAlign': 'right'}}>Edit</th>
    }
        </tr>
        </thead>

        <tbody>
        {_.map(entries, entry => {
            return <tr>
                {_.map(column_names, cn => {
                  let value = get(entry, cn);

                  if (cn === "state") {
                    value = ecosackState(value);
                  }

                  if (cn === "created" || cn === "last_updated") {
                    if (value) {
                      value = utc_timestamp_to_local_date_string(value);
                    }
                  }

                  if (cn === "timestamp") {
                    if (value) {
                      value = utc_timestamp_to_local_datetime_string(value);
                    }
                  }

                  if (cn === "lifecycle.picked_up") {
                    if (value) {
                      value = utc_timestamp_to_hours_ago_string(value);
                    } else {
                      value = "";
                    }
                  }

                  return <td style={{ padding: '10px' }}>{value}</td>;
                })}

                {window.innerWidth > 1080 &&
                    _.map(optional_column_names, cn => {
                    return <td style={{'padding':'10px'}}>{entry[cn]}</td>
                })
                }
        {view_request !== undefined &&
          <ViewComponent
            {...props}
            rowData={entry}
          />
        }
        {detail_get_url !== undefined &&
          <EditComponent
            {...props}
            rowData={entry}
          />
      }
            </tr>
        })
    }
    </tbody>
    </table>

    {numPages > 1 && createPaginationLinks(false)}

    {add_new_url !== undefined && <AddComponent {...props} />}

  </>)
}

export default PaginatedList